import PurchasedItem from './PurchasedItem.jsx';

export default PurchasedItem;


// WEBPACK FOOTER //
// ./src/components/PurchasedItem/index.jsx